import { render } from "./DashboardLimpieza.vue?vue&type=template&id=d5cf05da"
import script from "./DashboardLimpieza.vue?vue&type=script&lang=js"
export * from "./DashboardLimpieza.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__